var map = {
	"./shipo-icon-edit-check-list.svg": "189a",
	"./shipo-icon-edit-primary.svg": "b99a",
	"./shipo-icon-edit-upload-primary.svg": "14c5",
	"./shipo-icon-edit-upload.svg": "2e16",
	"./shipo-icon-edit.svg": "aa55"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "777f";